import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

console.log("App initializing...");

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error("Failed to find the root element. Make sure <div id='root'></div> exists in index.html");
} else {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
    console.log("App rendered successfully.");
  } catch (error) {
    console.error("Error during initial render:", error);
  }
}
